import { Comment } from '@/commonTypes';
import React from 'react';
import Ratings from '../CommentInside/Ratings';
import styles from './styles.module.css';
import AppTextArea from '@/components/common/AppTextArea';
import ConfirmationButton from '@/components/common/ConfirmationButton';
import MainIcons from '@/icons/main';

export default function CreateComment({
  comment,
  onChange,
  showAllRates = false,
  showRateTitle = false,
  sendFunction,
  cancelFunction,
}: {
  comment?: Comment;
  onChange?: (value: number | string, key: string) => void;
  showAllRates?: boolean;
  showRateTitle?: boolean;
  sendFunction: () => void;
  cancelFunction: () => void;
}) {
  console.log('comment==', comment);
  return (
    <div className={`${styles.wrapper}`}>
      <div className={`${styles.container}`} id="commentInsert">
        <AppTextArea
          value={comment?.content}
          onChange={(e: { target: { value: string } }) => {
            onChange && onChange(e.target.value, 'content');
          }}
          placeholder="دیدگاه خود را بنویسید..."
          wrapper={`lightInput ${styles.textareaContact}`}
          extraWrapperClass={`${styles.extraWrapperClass}`}
          error={comment?.check?.message}
          showError={comment?.check?.error}
          showTitle={false}
          title="commentInput"
        />
        <Ratings
          item={comment}
          onChange={onChange}
          showAllRates={showAllRates}
          showRateTitle={showRateTitle}
          className={`${styles.ratings}`}
        />
      </div>
      <ConfirmationButton
        rejectText={
          <>
            <MainIcons.send />
            ارسال دیدگاه
          </>
        }
        confirmText={comment?.id ? 'انصراف' : null}
        rejectFunction={() => {
          sendFunction();
        }}
        confirmFunction={() => {
          cancelFunction();
        }}
        // extraConfirmStyle={extraConfirmStyle}
        extraConfirmStyle={`btn btn-white`}
        className={`${styles.buttonsContainer}`}
        rejectDisabled={!comment?.content || comment?.content?.length == 0}
      />
    </div>
  );
}
